export const ACTION_POST_CREATE_NOVELTIES = "ACTION_POST_CREATE_NOVELTIES";
export const ACTION_PUT_UPDATE_NOVELTIES = "ACTION_PUT_UPDATE_NOVELTIES";
export const ACTION_DELETE_NOVELTIES = "ACTION_DELETE_NOVELTIES";
export const ACTION_GET_NOVELTIES = "ACTION_GET_NOVELTIES";